<template>

    <div class="rendezvous-grid">
        <div class="grid-item">

            <h3 class="steps-header">
                {{getHeading}}
            </h3>

            <form v-on:submit.stop.prevent="handleSubmit">
                <p v-if="errorMessage"
                   class="form-message error">
                    {{ errorMessage }}
                </p>

                <div class="code-wrapper">
                    <LabelInput
                        :inputConfig="fieldConfigs.regCode"
                        :errorMessage="fieldErrors.regCode"
                        @input="handleInput">
                    </LabelInput>
                    <div v-if="fieldErrors.regCode"
                        class="text-input-error">
                        {{ fieldErrors.regCode }}
                    </div>
                </div>

                <FormButton
                    :buttonConfig="submitButtonConfig"
                    :buttonState="buttonState"
                    @click="handleSubmit">
                </FormButton>

            </form>

            <p class="faq-copy" v-html="getFAQText"></p>

        </div>
    </div>

</template>

<script>

    import {mapState} from 'vuex'
    import {sprintf} from 'sprintf-js'
    import FormButton from 'atoms/FormButton'
    import LabelInput from 'atoms/LabelInput'
    import {ButtonState, default as ButtonConfig} from 'models/ButtonConfig'
    import PageAttributes from "aa/vue/models/PageAttributes";

    const REG_CODE_LENGTH = 7;

    export default {
        name: 'TVERendezvousCode',
        props: {
            errorMessage: null
        },
        data: function () {

            let pageAttr = this.$store.state.pageAttributes.attributes || new PageAttributes();

            return {
                regCode: '',

                form: {
                    tk_trp: this.$store.state.token
                },

                fieldConfigs: {
                    regCode: {
                        type: 'text',
                        name: 'regCode',
                        id: 'regCode',
                        ref: 'regCode',
                        label: pageAttr.tve_rendezvous_code_label,
                        value: null,
                        maxlength: REG_CODE_LENGTH,
                        validation: ['required'],
                        autoComplete: 'off'
                    },
                },
                fieldErrors: {
                    regCode: null,
                },
                formMessage: null,
            }
        },
        computed: {

            getHeading() {
                return sprintf(this.pageAttr.tve_rendezvous_code_heading, this.deviceName)
            },

            getFAQText() {
                return sprintf(this.pageAttr.tve_rendezvous_code_faq_text, `/${this.flow.type}/help/`)
            },

            buttonState() {
                return this.canSubmit()
                    ? ButtonState.Enabled
                    : ButtonState.Disabled
            },

            submitButtonConfig() {
                return new ButtonConfig({
                    type: 'button',
                    displayText: this.pageAttr.tve_rendezvous_code_cta_text,

                })
            },

            ...mapState('pageAttributes', {
                pageAttr: state => state.attributes
            }),

            ...mapState('flow', {
                flow: state => state.config,
                deviceName: state => state.config.rendezvous ? state.config.rendezvous.displayName : null,
            }),

        },
        methods: {

            canSubmit() {
                return this.regCode.length === REG_CODE_LENGTH;
            },

            emitRegCode() {
                this.$emit('regCode', {
                    regCode: this.regCode
                });
            },
            handleInput: function (e) {
                if (typeof e.value === 'string') {
                    this.regCode = e.value;
                } else {
                    this.regCode = '';
                }
            },
            handleSubmit() {
                if (this.canSubmit()) {
                    this.emitRegCode();
                }
            },
        },
        components: {
            LabelInput,
            FormButton
        },
        watch: {}
    }
</script>
